module.exports = __webpack_public_path__ + "img/img-13.4d550cc6.png";